import {
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import { Field, FieldProps } from 'formik';
import {  useEffect } from 'react';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from './base-url-params-filter';
import { useSearchParams } from 'react-router-dom';

type OptionItem<ValueType> = {
  value: ValueType;
  label: string;
};

type Props<ValueType extends string | number = number> = BaseUrlParamsFilterProps & {
  defaultValue?: ValueType;
  items: OptionItem<ValueType>[];
};

/**
 * Простой Select с поддержкой url params
 */
export const SimpleSelectUrlParamsFilter = <ValueType extends string | number = number>({
  queryParamName,
  label,
  defaultValue,
  items,
  size = 'medium'
}: Props<ValueType>) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (defaultValue && !searchParams.get(queryParamName)) {
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.set(queryParamName, defaultValue.toString());
        return newParams;
      }, { replace: true });
    }
  }, []);


  return (
    <BaseUrlParamsFilter queryParamName={queryParamName} defaultValue={defaultValue}>
      <Field name={queryParamName}>
        {({ field }: FieldProps<string>) => {

          return (
            <FormControl fullWidth size={size}>
              <InputLabel>{label}</InputLabel>
              <Select
                {...field}
                label={label}
                value={field.value ?? ''}
                onChange={(e) => {
                  field.onChange(e);
                }}
              >
                {items.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        }}
      </Field>
    </BaseUrlParamsFilter>
  );
};
